/** Fallback when HTMLAudioElement `ended` never fires so a play queue can't stall. */
export const playbackEndTimeoutMs = (
  durationSec: number | undefined,
): number => {
  if (
    typeof durationSec === "number" &&
    Number.isFinite(durationSec) &&
    durationSec > 0
  ) {
    return durationSec * 1000 + 150;
  }
  return 3000;
};
